import "./App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from './assets/Logo-DreammaewShop.png';
import { Row, Col, Container } from 'react-bootstrap';

function App() {

  const [phoneNo, setPhoneNo] = useState("");
  const [searchText, setSearchText] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [customerOrderDetails, setCustomerOrderDetails] = useState({});

  const onSearchTextChange = ({ target: { value } }) => {
    setSearchText(value);
  };
  const searchPhoneNo = () => {
    setPhoneNo(searchText);
  };

  const fetchDataCustomerOrder = async () => {
    try {
      setLoading(true);
      const url = "https://script.google.com/macros/s/AKfycbzwmR4ExEwmRFsElkF6HT5RfZy1ycGnn3XTMTu-T4MuyxMF1GokhUaizpAFEqtjoeGYYw/exec?actionInput=getCustomerOrderDataByPhoneNo&searchInput=";
      const { data } = await axios(url + phoneNo);
      setCustomerOrderDetails(data);
  } catch (error) {
      console.error("Error fetching data", error);
  } finally {
      setLoading(false);
  }
  };

  useEffect(() => {
    window.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('.footer');
    const container = document.querySelector('.container');
    if (footer && container) {
        const footerHeight = footer.offsetHeight;
        container.style.paddingBottom = `${footerHeight}px`;
    }
});

  })

  useEffect(() => {
    setLoading(true);
    fetchDataCustomerOrder();
    //console.log({customerOrderDetails});
    // eslint-disable-next-line
  }, [phoneNo]);

  return (
      <div>
        <div className="banner">
          <img src={logo} className="logo" alt="shop-logo"></img>
          <div className="search-panel">
            <input
              type="text"
              placeholder="กรอกเบอร์โทรศัพท์ที่ใช้ในการสั่งซื้อสินค้า..."
              value={searchText}
              onChange={onSearchTextChange}
              maxLength={10}
              />
            <button type="submit" style={{ marginLeft: "10px" }} onClick={searchPhoneNo}>
              {" "}
              Search{" "}
            </button>
          </div>
        </div>

        <div className="bodyContent">
          <div className="orderList">
            {isLoading ? (
              <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                <div className="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              ) : (
              <Container className="container">
                <Row className="row">
                  {customerOrderDetails?.orderDetails?.map((item, index) => (
                    <Col key={index} className="col-lg-4 col-md-6 col-sm-12">
                      <div className="orderCard">
                        <div className="orderCard-orderNameContainer" style={{backgroundColor : item?.statusColor?.color, color: item?.statusColor?.textColor}}>
                          {item?.orderName}
                          {item?.orderStatus === "ส่งแล้ว" && (
                            <div className="orderCard-orderStatusTag">
                              ส่งแล้ว
                            </div>
                          )}
                        </div>
                        <div className="orderCard-orderDetailContainer">
                          <p>ที่อยู่ในการจัดส่ง: </p>
                          <p>{item?.address}</p>
                          {item?.orderStatus !== "ส่งแล้ว" && (
                            <p>สถานะ: <strong style={{color : item?.statusColor?.textColor}}>{item?.orderStatus}</strong></p>
                          )}
                          <p>ยอดค้างชำระ: {item?.remaining > 0 && (<span>{item?.remaining} บาท</span>)}</p>
                          <p>หมายเหตุ: {item?.note}</p>
                          {item?.orderStatus === "สำเร็จ" && (
                            <p>
                              Tracking No.: <a href={item?.shippingCompany.api + item?.trackingNo} target="_blank"  rel="noopener noreferrer" style={{color : item?.shippingCompany.color}}><strong>{item?.trackingNo}</strong></a>  
                            </p>
                          )}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
            )}
          </div>
        </div>

        <footer className="footer">
          <div className="footer-accu">
            <label htmlFor="accuPts">ยอดสะสม:{" "}</label>
            <input
              id="accuPts"
              type="text"
              className="footer-input"
              value={customerOrderDetails?.accumulatePoint > 0 ? customerOrderDetails?.accumulatePoint : 0}
              readOnly
              ></input>
          </div>
          <div className="footer-review">
            <label htmlFor="reviewPts">ยอดรีวิว:{" "}</label>
            <input
              id="reviewPts"
              type="text"
              className="footer-input"
              value={customerOrderDetails?.reviewPoint > 0 ? customerOrderDetails?.reviewPoint : 0}
              readOnly
              ></input>
          </div>
        </footer>
      </div>
  );
}

export default App;

/*
<section  id="bodyContent" className="bodyContent">
    <div className="orderList">
      {isLoading ? (
        <div>
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          //{ ตัว spinner ตอนโหลดข้อมูลค่า }
        </div>
        ) : (
        <div>
          <div className="row mt-3">
            {customerOrderDetails?.orderDetails?.map((item, index) => (
              // <li key={index}>
              <div key={index} className="col-lg-4 col-md-6 col-sm-12 mt-3 orderCol">
                //{ <div className="col-1"></div> }
                <div className="orderCard">
                  <div className="orderCard-orderNameContainer" style={{backgroundColor : item?.statusColor?.color, color: item?.statusColor?.textColor}}>
                    {item?.orderName}
                    {item?.orderStatus === "ส่งแล้ว" && (
                      <div className="orderCard-orderStatusTag">
                        ส่งแล้ว
                      </div>
                    )}
                  </div>
                  <div className="orderCard-orderDetailContainer">
                    <p>ที่อยู่ในการจัดส่ง: </p>
                    <p>{item?.address}</p>
                    {item?.orderStatus !== "ส่งแล้ว" && (
                      <p>สถานะ: <strong style={{color : item?.statusColor?.textColor}}>{item?.orderStatus}</strong></p>
                    )}
                    <p>ยอดค้างชำระ: {item?.remaining > 0 && (<span>{item?.remaining} บาท</span>)}</p>
                    <p>หมายเหตุ: {item?.note}</p>
                    {item?.orderStatus === "สำเร็จ" && (
                      <p>
                        Tracking No.: <a href={item?.shippingCompany.api + item?.trackingNo} style={{color : item?.shippingCompany.color}}><strong>{item?.trackingNo}</strong></a>  
                        //{ (<span style={{color : item?.tracking.color}}>{item?.shippingCompany}</span>) }
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  </section>
*/